
import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';
import { ATWAvatar } from '@/components/icons/ATWAvatar';

type SidebarHeaderProps = {
  collapsed: boolean;
  isMobile: boolean;
  onToggleExpand: () => void;
};

const SidebarHeader = ({ collapsed, isMobile, onToggleExpand }: SidebarHeaderProps) => {
  return (
    <div className={cn(
      "h-16 flex items-center border-b border-border px-4",
      (!collapsed || isMobile) ? "justify-between" : "justify-center relative"
    )}>
      {(!collapsed || isMobile) ? (
        <div className="font-semibold text-xl tracking-tight">
          <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" x="0" y="0" version="1.1" viewBox="0 0 471.9 123.4" className="h-8 w-auto">
            <path d="M296.1 26.6c-3.1.2-6.2 0-9.5 0v-10c3.2-1.2 5.5-4.4 5.5-8 0-4.7-3.8-8.6-8.6-8.6-4.7 0-8.6 3.8-8.6 8.6 0 3.7 2.4 6.9 5.7 8.1v10h-15.4c-6.9.1-13.5 1.5-19.3 5.5-10.9 7.6-13.6 18.4-13.4 31 .4 19.9 12.9 32.9 32.7 33 12.3.1 24.6.2 37-.1 4.3-.1 8.7-.8 12.7-2.2 11.9-4.2 18.9-15.7 19.8-28.5 1.7-26.7-14.5-40.7-38.6-38.8zm25 39.9c-.8 9.1-7 14.8-16.2 14.8h-21.5c-7.3 0-14.7.1-22 0-8-.1-13.8-5.2-15.2-13.1-.2-1.3-.3-2.6-.4-4-1.1-15.4 4.3-23.9 22.4-23.1 12 .6 24 .1 36 .1 10.4.1 16.8 6.3 17.1 16.7 0 3 0 5.8-.2 8.6zm-22.8 35.9c-5.3 2.4-9.9 4.4-14.4 6.4-.3.1-.6.1-.8 0-4.6-2.1-9.2-4.1-14.4-6.4-.7-.3-1.4.2-1.4.9v19.1c0 .7.8 1.2 1.4.9 5.3-2.3 9.9-4.4 14.5-6.4.3-.1.6-.1.8 0 4.7 2.1 9.2 4.1 14.4 6.4.7.3 1.4-.2 1.4-.9v-19.1c-.1-.8-.8-1.2-1.5-.9z" className="fill-foreground" />
            <path d="M300.8 54.8c-1.8 0-3.4.7-4.7 1.9l-.3.3c-1.1 1.2-1.7 2.8-1.7 4.5 0 3.7 3 6.7 6.7 6.7s6.7-3 6.7-6.7-3-6.7-6.7-6.7z" className="fill-foreground" />
            <circle cx="266.2" cy="61.5" r="6.7" className="fill-foreground" />
            <path d="M68.2 29.5h15.4v65.1H68.4l-.8-9.6c-3.7 7.7-13.9 11.4-21.1 11.5C27.3 96.7 13 84.8 13 61.9c0-22.4 14.9-34.2 33.9-34.1 8.7 0 17 4.1 20.7 10.6l.6-8.9zM29.1 61.9c0 12.4 8.6 19.8 19.3 19.8 25.3 0 25.3-39.5 0-39.5-10.7.1-19.3 7.3-19.3 19.7zM91 44.6v28.1c0 16.2 9.2 24.3 23.4 23.8 2.7-.1 5-.3 7.4-.9v-15c-2 .8-4.3 1.3-6.3 1.3-5.1-.1-8.5-3.1-8.5-9.3V44.5h13.3V30.6h-13.2V13.9H91v30.7zm93.9-15.3 14.3 49 14.9-49h17.8l-22.7 65.5h-18.7l-6.7-19.3-5.8-21.8-5.8 21.8-6.7 19.3h-18.7L124 29.3h18l14.9 49 14.1-49h13.9zm175 .2 1.2 7.5c5-8.1 11.7-9.2 18.3-9.2 6.7 0 13.2 2.6 16.8 6.2L389 48c-3.3-2.8-6.3-4.2-11.6-4.2-8.4 0-16.2 4.5-16.2 16.5v34.3H345V29.5h14.9zM418 2.3v53.3l21.9-26.1h19.3v.9l-26.5 29.7 30.2 33.3v1.2h-19.4L418 65.1v29.4h-16.1V2.3H418z" className="fill-foreground" />
          </svg>
        </div>
      ) : (
        <div className="flex items-center justify-center">
          <ATWAvatar size={38} color="#2563EB" />
        </div>
      )}
      {!isMobile && (
        <button 
          onClick={onToggleExpand}
          className={cn(
            "h-6 w-6 rounded-full flex items-center justify-center hover:bg-muted transition-colors",
            collapsed && "absolute -right-3 bg-white dark:bg-background border border-border"
          )}
          aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          {collapsed ? <ChevronRight size={14} /> : <ChevronLeft size={14} />}
        </button>
      )}
    </div>
  );
};

export default SidebarHeader;
